// Environment configuration
export const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
  ENV: process.env.REACT_APP_ENV || 'development',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Procurement Dashboard'
};

// API endpoints
export const API_ENDPOINTS = {
  BASE_URL: config.API_BASE_URL,
  REQUESTS: `${config.API_BASE_URL}/requests`,
  REQUEST_DETAIL: (id: string) => `${config.API_BASE_URL}/requests/${id}`,
  PHASE1_REQUESTS: `${config.API_BASE_URL}/requests/phase1`,
  APPROVE_REQUEST: (id: string) => `${config.API_BASE_URL}/requests/${id}/approve`,
  REJECT_REQUEST: (id: string) => `${config.API_BASE_URL}/requests/${id}/reject`,
  ANALYZE_REQUEST: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/analyze`,
  ANALYZE_REQUEST_MORE: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/analyze/more`,
  REVISION_REQUEST: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/revision`,
  UPDATE_REVISION: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/update-revision`,
  LOCAL_SUPPLIERS: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/local-suppliers`,
  REVISION_NOTIFICATIONS: `${config.API_BASE_URL}/requests/notifications/revisions`,
  UPDATE_REQUEST: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/update`,
  SEND_SUPPLIER_EMAIL: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/send-email`,
  GET_EMAIL_TEMPLATE: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/email-template`,
  UPDATE_SUPPLIER_INFO: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/update-info`,
  ADD_SUPPLIER_TO_DATABASE: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/add-to-database`,
  ADD_SUPPLIER_WITH_PRODUCT: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/add-supplier-with-product`,
  ADD_OCR_TO_DATABASE: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/add-ocr-to-database`,
  MARK_EMAIL_RECEIVED: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/mark-email-received`,
  SUPPLIER_SEARCH: `${config.API_BASE_URL}/suppliers/search`,
  ADD_PRODUCT_TO_SUPPLIER: (supplier_id: string) => `${config.API_BASE_URL}/supplier-products/supplier/${supplier_id}`,
  USERS: `${config.API_BASE_URL}/users`,
  USER_REGISTER: `${config.API_BASE_URL}/users/register`,
  FORGOT_PASSWORD: `${config.API_BASE_URL}/users/forgot-password`,
  RESET_PASSWORD: `${config.API_BASE_URL}/users/reset-password`,
  SUPPLIERS: `${config.API_BASE_URL}/suppliers`,
  OFFERS: `${config.API_BASE_URL}/offers`,
  // Supplier Products endpoints (replacing old company-products endpoints)
  SUPPLIER_PRODUCTS: (supplier_id: string) => `${config.API_BASE_URL}/supplier-products/supplier/${supplier_id}`,
  SUPPLIER_PRODUCT_DETAIL: (supplier_product_id: string) => `${config.API_BASE_URL}/supplier-products/${supplier_product_id}`,
  SUPPLIER_PRODUCTS_BULK_UPDATE: `${config.API_BASE_URL}/supplier-products/bulk-update`,
  UPLOAD_SUPPLIER_DOCUMENT: `${config.API_BASE_URL}/supplier-products/upload-document`,
  DOWNLOAD_SUPPLIER_DOCUMENT: (document_id: string) => `${config.API_BASE_URL}/supplier-products/download-document/${document_id}`,
  GET_SUPPLIER_PRODUCT_DOCUMENTS: (supplier_product_id: string) => `${config.API_BASE_URL}/supplier-products/${supplier_product_id}/documents`,
  // Companies endpoints
  COMPANIES: `${config.API_BASE_URL}/companies`,
  COMPANY_NAME: (company_id: string) => `${config.API_BASE_URL}/companies/${company_id}/name`,
  // Issues endpoints
  ISSUES_REPORT: `${config.API_BASE_URL}/issues/report`,
  ISSUES_ADMIN_LIST: `${config.API_BASE_URL}/issues/admin/list`,
  // Savings endpoints
  COMPANY_SAVINGS: (company_id: string) => `${config.API_BASE_URL}/companies/${company_id}/savings`,
  COMPANY_TOTAL_SPEND_PIPELINE: (company_id: string) => `${config.API_BASE_URL}/companies/${company_id}/total-spend-pipeline`,
  COMPANY_COMMITTED_SPEND: (company_id: string) => `${config.API_BASE_URL}/companies/${company_id}/committed-spend`,
  COMPANY_YEARLY_OVERVIEW: (company_id: string) => `${config.API_BASE_URL}/companies/${company_id}/yearly-overview`,
  COMPANY_REQUESTS_DEBUG: (company_id: string) => `${config.API_BASE_URL}/companies/${company_id}/requests-debug`,
  // Legacy endpoints (kept for compatibility but deprecated)
  PRODUCTS: `${config.API_BASE_URL}/products`,
  PRODUCT_SEARCH: `${config.API_BASE_URL}/products/search`,
  ADD_PRODUCT_TO_COMPANY: (company_id: string) => `${config.API_BASE_URL}/products/company/${company_id}/add`,
  // Email endpoints
  SENT_EMAILS: `${config.API_BASE_URL}/emails/sent`,
  EMAIL_HISTORY: (request_id: string, supplier_name: string) => `${config.API_BASE_URL}/emails/history/${request_id}/${supplier_name}`,
  SEND_REPLY: `${config.API_BASE_URL}/emails/send-reply`,
  
  // Mailgun endpoints
  MAILGUN_SETUP_WEBHOOKS: `${config.API_BASE_URL}/mailgun/setup-webhooks`,
  MAILGUN_SEND_TEST_EMAIL: `${config.API_BASE_URL}/mailgun/send-test-email`,
  // Admin notifications endpoints
  ADMIN_NOTIFICATIONS: `${config.API_BASE_URL}/requests/notifications/admin`,
  // OCR endpoints
  OCR_PROCESS_UPLOAD: `${config.API_BASE_URL}/ocr/process-upload`,
  OCR_PROCESS_BASE64: `${config.API_BASE_URL}/ocr/process-base64`,
  OCR_UPLOAD_AND_PROCESS: `${config.API_BASE_URL}/ocr/upload-and-process`,
  OCR_LOGS: `${config.API_BASE_URL}/ocr/logs`,
  // Company addresses endpoints
  COMPANY_ADDRESSES: (company_id: string) => `${config.API_BASE_URL}/companies/${company_id}/addresses`,
  COMPANY_ADDRESS: (company_id: string, address_id: string) => `${config.API_BASE_URL}/companies/${company_id}/addresses/${address_id}`,
  COMPANY_ADDRESS_DEFAULT: (company_id: string, address_id: string) => `${config.API_BASE_URL}/companies/${company_id}/addresses/${address_id}/set-default`,
  // PDF endpoints
  GENERATE_RFQ_PDF: (request_id: string) => `${config.API_BASE_URL}/pdf/rfq/${request_id}`,
  TEST_CORS: `${config.API_BASE_URL.replace('/api', '')}/test-cors`,
  // Edit endpoints
  UPDATE_SUPPLIER: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/update-supplier`,
  UPDATE_PRODUCT: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/update-product`,
  // Invoice endpoints
  INVOICE_UPLOAD: `${config.API_BASE_URL}/invoices/upload`,
  INVOICE_LIST: `${config.API_BASE_URL}/invoices/list`,
  INVOICE_DOWNLOAD: (pdfId: string) => `${config.API_BASE_URL}/invoices/download/${pdfId}`,
  INVOICE_DELETE: (pdfId: string) => `${config.API_BASE_URL}/invoices/delete/${pdfId}`,
  // Demo Istek endpoints
  DEMO_ISTEK_BY_INVOICE: (invoiceId: string) => `${config.API_BASE_URL}/demo-istek/by-invoice/${invoiceId}`,
  DEMO_ISTEK_UPLOAD: `${config.API_BASE_URL}/demo-istek/upload`,
  DEMO_ISTEK_LIST: `${config.API_BASE_URL}/demo-istek/list`
};

// Development helpers
export const isDevelopment = config.ENV === 'development';
export const isProduction = config.ENV === 'production';

// Test CORS connection
export const testCorsConnection = async () => {
  try {
    const response = await fetch(API_ENDPOINTS.TEST_CORS);
    const data = await response.json();
    console.log('✅ CORS Test Success:', data);
    return true;
  } catch (error) {
    console.error('❌ CORS Test Failed:', error);
    return false;
  }
};

// Test CORS connection on startup in development
if (isDevelopment) {
  testCorsConnection();
} 